import { get } from "./axios";

const AdminService = {
  getGlobalValue(name: string) {
    return get(`global-value?name=${name}`);
  }
};

export default AdminService;
